import { render, staticRenderFns } from "./detailOrganizationalManagement.vue?vue&type=template&id=f00b95d4&scoped=true&"
import script from "./detailOrganizationalManagement.vue?vue&type=script&lang=js&"
export * from "./detailOrganizationalManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b95d4",
  null
  
)

export default component.exports